import '../../../../components/kpi-boxed-values/KpiBoxedValues.scss'
import React from "react";
import {Card, CardContent, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useStores} from "../../../../stores";
import {observer} from "mobx-react-lite";

export const SampleOverview: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores();
    const stats = categorizationReviewStore.reviewPageController.reviewPageStatisticsController.sampleStatistics;
    const colorClass = stats && stats.sample_review_progress.reviewed < stats.sample_target_size ? 'value-warning' : '';
    return <Grid container className="kpi-boxed-values" spacing={3}>
        <Grid size={4}>
            <Card variant="elevation" elevation={0} className="kpi-card">
                <CardContent>
                    <Typography variant="h2" className="kpi-title" component="h2">
                        Reviewed
                    </Typography>
                    <Typography variant="h2" className={"font-weight-bold kpi-value " + colorClass} component="h2">
                        {stats
                            ? stats.sample_review_progress.reviewed
                            : <>&nbsp;</>}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
        <Grid size={4}>
            <Card variant="elevation" elevation={0} className="kpi-card">
                <CardContent>
                    <Typography variant="h2" className="kpi-title" component="h2">
                        Target
                    </Typography>
                    <Typography variant="h2" className="font-weight-bold kpi-value" component="h2">
                        {stats
                            ? stats.sample_target_size
                            : <>&nbsp;</>}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
        <Grid size={4}>
            <Card variant="elevation" elevation={0} className="kpi-card">
                <CardContent>
                    <Typography variant="h2" className="kpi-title" component="h2">
                        Maximum
                    </Typography>
                    <Typography variant="h2" className="font-weight-bold kpi-value" component="h2">
                        {stats
                            ? stats.sample_review_progress.total
                            : <>&nbsp;</>}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    </Grid>;
})
